import { Component, Inject, OnInit } from '@angular/core';
import moment from 'moment';
import { IResponse } from 'src/app/shared/models/app';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { HomeService } from 'src/app/modules/home/home.service';
import { MatDialogRef} from '@angular/material/dialog';
import { CommonService } from '../../common.service';
import { ToastService } from 'src/app/shared/utils/toast.service';
import { DateFormat } from 'src/app/core/constants/app.constant';

@Component({
    selector: 'nphs-wo-reject-notification',
    templateUrl: './reject-notification.component.html',
    styleUrls: ['./reject-notification.component.scss'],
    standalone: false
})
export class RejectNotificationComponent implements OnInit {

  rejectedNotificationData = [];
  selectAllNotification:boolean = false;
  rejectMessages:any = [];
  disableClearSelectedBtn:boolean = true;

  constructor(private homeService: HomeService,
    private commonService: CommonService,
    private cache: CacheResolverService,
    public dialog: MatDialogRef<RejectNotificationComponent>,
    private toastService: ToastService,
    public dialogRef: MatDialogRef<any>,
    ) { }

  ngOnInit(): void {
    this.Init()
  }

  private Init() {
    this.getRejectedNotificationsData();
  }

  private getRejectedNotificationsData() {
    let data = this.homeService.getDateAccNumber();
    this.homeService.getRejectedNotificationDetails(data).subscribe((response: IResponse) => {

      if(!response.hasError)
      {
        if(response.data != null && response.data.length > 0)
        {
          this.commonService.rejectedRequestChanged$.next(response.data?.length);

          this.transformRejectedNotification(response.data);
        }
        else{
          this.commonService.rejectedRequestChanged$.next(0);

          this.dialogRef.close();
        }

      }
      else
      {
        const message = response.error.faultInfos[0];
        this.toastService.error(message.faultMessage, 'ERROR!')
      }

    });
  }

  transformRejectedNotification(response) {
    this.rejectedNotificationData = response;
    let rejectedNotificationData = [];
    if (response) {
      response.forEach((item, index) => {
        rejectedNotificationData[index] = (item);
        rejectedNotificationData[index].calibrationTime = moment(new Date(item.calibrationTime)).format(DateFormat.HHMM);
        rejectedNotificationData[index].rejectTime = moment(new Date(item.rejectTime)).format(DateFormat.MMDDYYYYHMM)
      })
    }
    return rejectedNotificationData;
  }

  clearAll(checked) {
    this.rejectMessages = [];
    if (checked) {
      this.selectAllNotification = true;
      this.disableClearSelectedBtn = false;
      this.rejectedNotificationData.forEach((message) => {
        this.rejectMessages.push({
          "rejectedMsgNumber": message.rejectedMsgNumber,
          "acknowledged": true
        });
        message.acknowledged = true;
        return;
      });
    }
    else {
      this.rejectedNotificationData.forEach((message) => {
        message.acknowledged = false;
        return;
      });
      this.rejectMessages = [];
      this.selectAllNotification = false;
      this.disableClearSelectedBtn = true;
    }
  }

  clear(obj,checked) {
    if (checked) {
        this.rejectMessages.push({
          "rejectedMsgNumber": obj.rejectedMsgNumber,
          "acknowledged": true
        });
        obj.acknowledged = true;
    }
    else {
      let index = this.rejectMessages.findIndex(i => i.rejectedMsgNumber === obj.rejectedMsgNumber);
      this.rejectMessages.splice(index,1);
      obj.acknowledged = false;

    }
    if(this.rejectMessages.length === this.rejectedNotificationData.length) {
      this.selectAllNotification = true;
    }
    else{
      this.selectAllNotification = false;
    }
    if(this.rejectMessages.length > 0) {
      this.disableClearSelectedBtn = false;
    }
    else {
      this.disableClearSelectedBtn = true;
    }
  }

  closeDialog(showSuccessMsg){
    this.dialogRef.close();
    this.rejectMessages = [];
    this.rejectedNotificationData.forEach((message) => {
      this.rejectMessages.push({
        "rejectedMsgNumber": message.rejectedMsgNumber,
        "acknowledged": false
      });
    });
    this.saveRejectedNotification(showSuccessMsg);
  }

  saveRejectedNotification(showSuccessMsg){
    let reqPayloadObj = {
      customerShipToNum: this.cache.get(CacheConstant.LocalStorage.ShipTo),
      rejectMessages: this.rejectMessages,
    }
      this.homeService.acknowledgeRejectNotification(reqPayloadObj).subscribe((response: IResponse) => {
        if(!response.hasError)
        {
          this.disableClearSelectedBtn = true;
          if(showSuccessMsg){
            this.getRejectedNotificationsData();
            this.toastService.success("Rejected request acknowledged successfully!");
          }
        }
        else
        {
          const message = response.error.faultInfos[0];
          this.toastService.error(message.faultMessage, 'ERROR!')
        }
      });
  }


}

